import React from 'react';
import useData from './hooks';
import { VisibilitiesResolverProps } from './types';
import VisibilityResolver from './VisibilityResolver';
import { useFlattenFields } from '20.formLib/DeclarationContainer/contexts';
import { BaseQCOperator } from '90.quickConnect.Models/models';

/**
 * Ce composant permet des géré la visibilité des fields et de détermine ses dépendances
 * @param param0
 * @returns
 */
const VisibilitiesResolver = ({
  children,
  updateFieldVisibility,
  clearFieldVisibilityCache,
}: VisibilitiesResolverProps) => {
  const { flattenFields } = useFlattenFields();
  const { allHidableFields } = useData(flattenFields);

  return (
    <>
      {allHidableFields.map(({ id, fullPathId, visible, desactivatedAutomation }) => (
        <VisibilityResolver
          // Cle stable: un resolver n'est demonte (et son cache de visibilite purge) que si son champ disparait
          key={fullPathId}
          id={id}
          fullPathId={fullPathId}
          visible={visible as BaseQCOperator}
          desactivatedAutomation={desactivatedAutomation ?? false}
          updateFieldVisibility={updateFieldVisibility}
          clearFieldVisibilityCache={clearFieldVisibilityCache}
          flattenFields={flattenFields}
        />
      ))}
      {children}
    </>
  );
};

export default VisibilitiesResolver;
